export default __webpack_public_path__ + "static/media/zonapro-thin.01a04240.otf";